import React, { useEffect } from "react";

export function Toast({ message, type = "info", onDone, duration = 4000 }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => onDone && onDone(), duration);
    return () => clearTimeout(t);
  }, [message, duration, onDone]);
  if (!message) return null;
  const bg =
    type === "error" ? "#7f1d1d" : type === "success" ? "#065f46" : "#1e3a8a";
  const wrapStyle = { position: "fixed", bottom: 20, right: 20, zIndex: 9999 };
  const innerStyle = {
    background: bg,
    color: "#fff",
    padding: "12px 16px",
    borderRadius: 6,
    minWidth: 240,
    boxShadow: "0 4px 14px rgba(0,0,0,0.4)",
    fontSize: 14,
    fontWeight: 500,
  };
  return (
    <div style={wrapStyle}>
      <div style={innerStyle}>{message}</div>
    </div>
  );
}

export function useToast() {
  const [toast, setToast] = React.useState({
    message: "",
    type: "info",
    duration: 4000,
  });
  const show = (message, type = "info", duration = 4000) =>
    setToast({ message, type, duration });
  const clear = () => setToast({ message: "", type: "info", duration: 4000 });
  const node = (
    <Toast
      message={toast.message}
      type={toast.type}
      duration={toast.duration}
      onDone={clear}
    />
  );
  return { show, clear, ToastPortal: node };
}
